import { render, staticRenderFns } from "./CustomerNotes.vue?vue&type=template&id=133f6605&scoped=true"
import script from "./CustomerNotes.vue?vue&type=script&lang=js"
export * from "./CustomerNotes.vue?vue&type=script&lang=js"
import style0 from "./CustomerNotes.vue?vue&type=style&index=0&id=133f6605&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133f6605",
  null
  
)

export default component.exports